//REACT-JS
import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//COMPONENTS
import { relatorioAction } from '../../store/relatorio';

class TableDetalheContatoWhatsappToi extends React.Component {

    constructor(props) {
        super(props);
    }

    static defaultProps = {
        name: "",
        selected: 0,
        onChange: function(e){}
    };

    componentDidMount() {
    }

    statusEnvio(status){
        if (status == "Enviado"){
            return( <span style={{color:"#009966"}}>Enviado</span>)
        }
        else if (status == "Entregue"){
            return( <span style={{color:"#EF7800"}}>Entregue</span>)
        }
        else if (status == "Aberto"){
            return( <span style={{color:"#0099FF"}}>Abertura Link</span>)
        }
        else if (status == "Entregue Aparelho"){
            return( <span style={{color:"#0099FF"}}>Entregue no Aparelho</span>)
        }
        else if (status == "Rejeitado"){
            return( <span style={{color:"#C34E4E"}}>Não Entregue</span>)
        }
        else if (status == "Nao Enviado"){
            return(<td style={{color:"#C34E4E"}}>Não Enviado</td>)
        }
    }

    render() {

        const data = this.props.data; let html = "";

        let medidorVariavel;
        let instalacaoVariavel;

        if (data.results === undefined) {
            html = (<tr><td colSpan="7" scope="row">Carregando...</td></tr>);
        }
        else if (data.results.length === 0 || data.results === 0) {
            html = (<tr><td colSpan="7" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.results.length > 0) {
            html = data.results.map(row =>
                <tr key={row.identificador} id={row.codigo}>
                    <td>{row.identificador}</td>
                    <td style={{display: "none"}}>{row.nomeCampanha}</td>
                    <td>{row.telefone}</td>
                    <td>{this.statusEnvio(row.status)}</td>
                    <td style={{display: "none"}}>{row.empresa}</td>                    
                    <td style={{display: "none"}}>{row.uc}</td>
                    <td style={{display: "none"}}>{row.protocolo}</td>
                    <td style={{display: "none"}}>{row.documento}</td>
                    <td>{row.dataHoraEnvio}</td>
                    <td>{row.dataHoraEntrega}</td>
                    <td>{row.dataHoraAbertura}</td>
                    <td>{row.motivoNaoRecebimento}</td>
                    <td style={{display: "none"}}>{row.mailing}</td>
                </tr>                  
            );
        }

        if (data.results) {
            if (data.results.some(row => row.empresa === "3CSERVICE RJ")) {
                medidorVariavel = "Medidor";
                instalacaoVariavel = "Instalação"
            } else {
                medidorVariavel = "Protocolo";
                instalacaoVariavel = "UC"
            }
        }

        return(
            <div style={{maxHeight: "400px", overflowY: "auto"}}>
                <table className="footable table table-striped toggle-arrow-tiny text-body" id="table-to-export">
                    <thead>
                        <tr style={{backgroundColor: "#dbf1e9"}}>       
                            <th>Identificador</th>
                            <th style={{display: "none"}}>Rotina</th>
                            <th>Telefone</th>
                            <th>Status</th>
                            <th style={{display: "none"}}>Empresa</th>
                            <th style={{display: "none"}}>{instalacaoVariavel}</th>
                            <th style={{display: "none"}}>{medidorVariavel}</th>
                            <th style={{ display: "none" }}>Documento</th>
                            <th>Data/Hora do envio</th>
                            <th>Data/Hora da entrega</th>
                            <th>Data acesso WhatsApp</th>
                            <th>Motivo não recebimento</th>
                            <th style={{display: "none"}}>Mailing</th>
                        </tr>
                    </thead>

                    <tbody>{html}</tbody>
                </table>            
            </div>
        )
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth, relatorio: state.relatorio };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { relatorio: bindActionCreators(relatorioAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TableDetalheContatoWhatsappToi));